import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useParams, useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { packageServices } from "../../services/packageServices";
import _ from "lodash";
import axios from "axios";
import { getFileNameByPath, isEmptyDash } from "../../constant";
import PackageDocuments from "./packageDocuments.js";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import * as XLSX from "xlsx";
import AlertComponent from "../alert/alert";
import { UserObj } from "../../services/localStarage";
import { onboardingServices } from "../../services/onboardingServices";
import { projectServices } from "../../services/projectServices";
import { getSecPermission,trimString } from "../../constant";
import { Backdrop, CircularProgress } from "@mui/material";
import BulkUploadModal from "../common/bulkUpload";
import samplePackageFile from "../../assests/document/bulk_package_boq.xlsx";
import BoqDescriptionModal from "../common/boqDescriptionModal";
import checkImage from "../../assests/images/check-circle.png";
import Tooltip from '@mui/material/Tooltip';
import { Empty } from "antd";
import { rfqServices } from "../../services/rfqServices"; 
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import { use } from "react";
import ConfirmModal from "../common/confirmModal.js";

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const createTableArr1 = [
  { label: "Description", name: "description", value: "", options: [], errMsg: "" },
  { label: "HSN/SAC Code", name: "hsnSacCode", value: "", options: [], errMsg: "" },
  ...(UserObj?.role?.name === 'BUYER' ?
    [{ label: "PR Number", name: "prNumber", value: "", options: [], errMsg: "" }] : []),
  { label: "UOM", name: "uom", value: "", options: [], errMsg: "" },
  { label: "Quantity", name: "quantity", value: "", options: [], errMsg: "" }
];

function PackageDetail() { 
  let navigate = useNavigate();
  const [isDisable, setIsDisable] = useState(true);
  const [secPackagePermission, setSecPackagePermission] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [secEditPackagePermission, setSecEditPackagePermission] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [secEditPRNUMBERPermission, setSecEditPPRNUMBERPermission] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [secEditAssignBuyerPermission, setSecEditAssignBuyerPermission] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  useEffect(() => {
    let permissionObj = getSecPermission("PACKAGE_LISTING");
    let permissionEditPackageObj = getSecPermission("EDIT_PACKAGE");
    let permissionEditPRNumberObj = getSecPermission("ADD_PR_NUMBER","PACKAGE_DETAILS");    
    let permissionAssignBuyerObj = getSecPermission("ASSIGN_BUYER","PACKAGE_DETAILS");    
    setSecEditAssignBuyerPermission(permissionAssignBuyerObj);
    setSecEditPackagePermission(permissionEditPackageObj);
    setSecPackagePermission(permissionObj);
    setSecEditPPRNUMBERPermission(permissionEditPRNumberObj);
  }, []);

  const [deletePackageModal, setDeletePackageModal] = useState(false);

  const [createTableArr, setCreateTableArr] = useState(createTableArr1);
  const [openBulkUploadModal, setOpenBulkUploadModal] = React.useState(false);
  const requestPayloadInitials = {
    pageNumber: "",
    pageSize: "",
    sortArray: [],
    searchCriteria: [],
  };
  const [fileName, setFileName] = useState("");
  const [fileData, setFileData] = useState({ file: null, preview: "" });

  const [activeSubmitButton, setactiveSubmitButton] = useState(false);
  const [openeditboqpackage, setOpenEditBoqPackage] = useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDescription, setModalDescription] = useState("");
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [openboqupdatesuccessfully, setOpenBoqUpdateSuccessfully] =
    useState(false);

  const [formData, setFormData] = useState({
    projectName: "",
    location: "",
    capacity: "",
    COD: "",
  });
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [categoriyList, setCategoriyList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [packagedetailCreationlist, setPackageDetailCreationlist] =
    React.useState({
      boqs: [],
    });

  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [columns, setColumns] = useState();
  const { id } = useParams();
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [openCreateEmp, setOpenCreateEmp] = React.useState(false);
  const [fileInput, setFileInput] = useState([]);
  const [totalUOM, setTotalUOM] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalRate, setTotalRate] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [initialBoqs, setInitialBoqs] = useState([]);
  const [initialAssignedBuyer, setInitialAssignedBuyer] = useState([]);
  const [initialDocuments, setInitialDocuments] = useState([]);  
  const [activeProjectFields, setactiveProjectFields] = useState('');
  useEffect(() => {
    // getPackageDetail(requestPayload, filterText);
  }, [requestPayload]);

  useEffect(() => {
    updateTotals(packagedetailCreationlist.boqs);
  }, [packagedetailCreationlist.boqs]);

  const updateTotals = (boqs) => {
    let uomTotal = 0;
    let quantityTotal = 0;
    let rateTotal = 0;
    let amountTotal = 0;
    boqs.forEach((row) => {
      uomTotal += parseFloat(row.uom) || 0;
      quantityTotal += parseFloat(row.quantity) || 0;
      rateTotal += parseFloat(row.rate) || 0;
      amountTotal += parseFloat(row.amount) || 0;
    });
    setTotalUOM(uomTotal);
    setTotalQuantity(quantityTotal);
    setTotalRate(rateTotal);
    setTotalAmount(amountTotal);
  };

  useEffect(() => {
    packageServices
      .getPackageDetail(id)
      .then((res) => {
        if (res.data.success === true) {
          setPackageDetailCreationlist(res.data.data);
          setInitialBoqs(res.data.data.boqs);
          setInitialAssignedBuyer(res.data.data.buyer);
          getPackageFieldDetails();
          // setInitialDocuments(res.data.data.documents); 
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getCategoryForProjects();
    getDepartmentForProjects();
  }, []);

  const getDepartmentForProjects = (param) => {
    projectServices
      .getDepartmentForProjects()
      .then((res) => {
        if (res.data.success === true) {
          setDepartmentList(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const fileInputRef = useRef(null);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    let sFilename = file.name;
    let reader = new FileReader();
    let result = {};

    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });
        if (roa.length) result[sheetName] = roa;
      });
      // see the result, caution: it works after reader event is done. 
      setFileInput(result?.Sheet1[0]);
      setFileData(file);
    };
    reader.readAsArrayBuffer(file);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = sortOrder == "asc" ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLael;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const downloadFileWithUrl = (url, fileName) => {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: {
        "Access-Control-Allow-Origin": "*",
        cors: "no-cors",
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });
  };
  const viewMedia = (data) => {
    setIsLoading(true);
    packageServices
      .viewUrlData(data)
      .then(function (response) {
        if (response?.data?.success === true) {
          downloadFileWithUrl(
            `${response?.data?.data?.url}`,
            getFileNameByPath(data)
          );
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const handleClick = (document, index) => {  
    const documentData = {
      name: document.name,   
      response: document?.value?.response ,
      uniqueName : document?.uniqueName
    }; 
    setUploadFilesObj(documentData);
    setIsMediaListModalOpen(true);  
  };
  
  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

 

  const formatDateString = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };
  const dueDate = formatDateString(packagedetailCreationlist?.dueDate);

  const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

  useEffect(() => {
    // if (packagedetailCreationlist.boqs) {
    //   // setInitialBoqs(deepClone(packagedetailCreationlist.boqs));
    // }
    // if (packagedetailCreationlist.documents) {
    //   setInitialDocuments(deepClone(packagedetailCreationlist.documents));
    // }
  }, [packagedetailCreationlist.documents]);

  const isBoqEdited = (initialBoq, currentBoq) => {
    return (
      initialBoq.description !== currentBoq.description ||
      initialBoq.hsnSacCode !== currentBoq.hsnSacCode ||
      initialBoq.uom !== currentBoq.uom ||
      initialBoq.quantity !== currentBoq.quantity ||
      initialBoq.rate !== currentBoq.rate ||
      initialBoq.amount !== currentBoq.amount
    );
  };

  const isDocumentEdited = (initialDoc, currentDoc) => {
    // Compare fields to check if they are different
    if (!initialDoc || !currentDoc) return true;
  
    // Example comparison logic
    return (
      initialDoc.value?.response?.length !== currentDoc.value?.response?.length ||
      initialDoc.value?.response?.some((res, index) => 
        res.key !== currentDoc.value?.response[index]?.key ||
        res.fileName !== currentDoc.value?.response[index]?.fileName
      )
    );
  };

  const getDeletedBoqIds = (initialBoqs, currentBoqs) => {
    const currentBoqIds = currentBoqs.map((boq) => boq._id);
    return initialBoqs
      .filter((boq) => !currentBoqIds.includes(boq._id))
      .map((boq) => boq._id);
  };

  const navigateUrl = (param) => {
    navigate(param);
  };
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    if (packagedetailCreationlist?.dueDate) {
      setFormattedDate(formatDateForInput(packagedetailCreationlist.dueDate));
    }
  }, [packagedetailCreationlist]);

  const [editSubmitStatus, setEditSubmitStatus] = useState(null);
  const [editSubmitMessage, setEditSubmitMessage] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedBuyers, setSelectedBuyers] = useState([]);
  const transformDocuments = (document) => { 
    if (!Array.isArray(document) ) { 
      return [];  
    }
    return document.map((field) => ({
      documentName: field.name,
      uniqueName: field.uniqueName,
      response: field?.value?.response ? field?.value?.response.map((res) => ({
        key: res.key,
        fileName: res.fileName,
        _id: res?._id,  
      })) : [],  
      _id: field?.value?._id,  
    }));
  };

  const areRequiredDocumentsValid = () => {   
    const requiredDocuments = activeDocument?.filter((doc) => doc.required); 
    for (let doc of requiredDocuments) {
      if (!doc?.value?.response || doc?.value?.response.length === 0 || !doc?.value?.response[0].fileName) {
        return { valid: false, label: doc.name };  
      }
    } 
    return { valid: true };
  };

  const submitForm = (isSubmitting) => {    
    setEditSubmitStatus(isSubmitting); 
    const editedBoqs = packagedetailCreationlist.boqs.filter((currentBoq) => {
      if (!currentBoq._id) {
        return true;
      }
      const initialBoq = initialBoqs.find((boq) => boq._id === currentBoq._id);
      if (!initialBoq) {
        return true;
      }

      return isBoqEdited(initialBoq, currentBoq);
    });  

    const deletedBoqIds = getDeletedBoqIds(
      initialBoqs,
      packagedetailCreationlist.boqs
    );

    /** Check BOQ */
    const validateTableData = () => {
      for (const row of editedBoqs) {
        if (!row.description || !row.hsnSacCode || !row.uom || !row.quantity) {
          return { valid: false };
        }
      }
      return { valid: true };
    };
    const boqValidation = validateTableData();
    if (!boqValidation.valid) {
      setAlertComponent({
        open: true,
        type: "error",
        message: "Please fill the blank BOQ line item first to proceed ",
      });
      setIsLoading(false);
      return;
    } 
    if(!isEmptyDash(activeDocument)){
        const validation = areRequiredDocumentsValid();
        if (!validation.valid) {
          setAlertComponent({ open: true, type: "error", message: `The document "${validation.label}" is blank or invalid.` });
          return;
        }  
      } 
      
    const payload = {
      isSubmitting: isSubmitting,
      packageName: packagedetailCreationlist?.packageName,
      packageType: packagedetailCreationlist?.packageType,
      categoryId: packagedetailCreationlist?.categoryId,
      subcategoryId: packagedetailCreationlist?.subcategoryId,
      departmentId: packagedetailCreationlist?.departmentId,
      description: packagedetailCreationlist?.description,
      remarks: packagedetailCreationlist?.remarks,
      // "dueDate": packagedetailCreationlist?.dueDate,
      // dueDate: formattedDate,
      purchaseType: packagedetailCreationlist?.purchaseType,
      boqIdsToDelete: deletedBoqIds,
      boqs: editedBoqs,
      documents: transformDocuments(activeDocument), 
      // buyer: packagedetailCreationlist?.assignBuyer,
    };
    if (packagedetailCreationlist?.assignBuyer !== '' && packagedetailCreationlist?.assignBuyer !== undefined) {
      payload.buyer = packagedetailCreationlist?.assignBuyer;
   } else{
    payload.buyer = selectedBuyers;
   }

   let additionalFieldsInit = {};
   for(let key in packagedetailCreationlist?.additionalFields){
    additionalFieldsInit[key] = packagedetailCreationlist[key] || packagedetailCreationlist?.additionalFields[key];
   }
   payload["additionalFields"] = additionalFieldsInit;
  //  console.log("packagedetailCreationlist: ", packagedetailCreationlist, payload, additionalFieldsInit);
    setIsLoading(true);
    packageServices
      .editPackage(id, payload)
      .then((res) => {
        if (res.data.success === true) { 
          setOpenBoqUpdateSuccessfully(true);
          setEditSubmitMessage(res.data.message);
          setInitialBoqs(res.data.data.boqs);
          setInitialDocuments(res.data.data.documents); 
        } else {
          setIsLoading(false);
          openAlert(true, "error", `${res?.data?.data?.message}`);
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const [tableData, setTableData] = useState([]);
  const [editPackage, setEditPackage] = useState(false);
  const [editMultiUpload, setEditMultiUpload] = useState(false);

  const onEditClk = () => {
    setIsDisable(false);
    setactiveSubmitButton(true);
    setEditPackage(true);
    setEditMultiUpload(true);
    addIsAlertUnsavedData();
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const onImport = () => {
    if (fileInput.length < 1) {
      openAlert(true, "error", `Please select valid excel file.`);
      return;
    }
    setOpenCreateEmp(false);
    setOpenDefaulfFields(true);
  };
  const closeCreateEmp = () => {
    setOpenCreateEmp(false);
    setFileInput([]);
    setFileData(null);
  };

  const onTextChange = (
    e,
    cell,
    rowIndex,
    column,
    packagedetailCreationlistParam
  ) => {
    const { name, value } = e.target;
    let updatedValue = value;
    if (name === "packageName") {
      updatedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      // [name]: value,
      [name]: updatedValue,
    }));
  };

  useEffect(() => {
    if (packagedetailCreationlist.categoryId) {
      let arr = categoriyList.filter(
        (ele) => ele?._id === packagedetailCreationlist.categoryId
      );
      setSubCategoryList(arr[0]?.subcategories || []);
    }
  }, [categoriyList, packagedetailCreationlist.categoryId]);

  const onFieldChange = (value, secName) => { 
    addIsAlertUnsavedData();
    if (secName === "categoryId") {
      setPackageDetailCreationlist((prevState) => ({
        ...prevState,
        subcategoryId: "",
      }));
      let arr = categoriyList.filter((ele) => ele?._id === value);
      setSubCategoryList(arr[0]?.subcategories);
    }
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      [secName]: value,
    }));
  };

  const [rows, setRows] = useState([
    {
      id: 1,
      itemNo: 1,
      description: "Sample BOQ",
      hsnSacCode: "1234",
      uom: "Sample UOM",
      quantity: "10",
      rate: "5",
      amount: "50",
    },
  ]);

  const addRow = () => {
    const newRow = {
      // _id: Date.now().toString(),
      // itemNo: rows.length + 1,
      description: "",
      hsnSacCode: "",
      uom: "",
      quantity: "",
      // rate: "",
      // amount: "",
    };
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      boqs: [...prevState.boqs, newRow],
    }));
    // setRows([...rows, newRow]);
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({ id: null, index: null });

  const confirmDelete = (id, i) => {
    setDeleteTarget({ id, index: i });
    setShowConfirmation(true);
  };


  const handleConfirm = () => {
    const { id, index } = deleteTarget;
    deleteRow(id, index);
    openAlert(true, "success", `Line item Deleted Successfully`);
    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const deleteRow = (id, i) => {
    addIsAlertUnsavedData();
    if (id) {
      setPackageDetailCreationlist((prevState) => {
        const updatedBoqs = prevState.boqs.filter((row) => row._id !== id);
        return {
          ...prevState,
          boqs: updatedBoqs,
        };
      });
    } else {
      setPackageDetailCreationlist((prevState) => {
        const updatedBoqs = prevState.boqs.filter((row, idx) => i !== idx);
        return {
          ...prevState,
          boqs: updatedBoqs,
        };
      });
    }
  };

  // const handleChange = (id, field, value, i) => {
  //   const tableDataInit = _.cloneDeep(packagedetailCreationlist?.boqs);
  //   tableDataInit[i][field] = value;
  //   setPackageDetailCreationlist((prevState) => ({
  //     ...prevState,
  //     boqs: tableDataInit,
  //   }));
  // };
  const handleChange = (id, key, value, index) => {
    addIsAlertUnsavedData();
    if ((key === "quantity" || key === "hsnSacCode") && Number(value) < 0) {
      return; // Exit the function if the value is negative
    }
    if (key === "quantity") {
      // Prevent negative numbers
      if (Number(value) < 0) {
        return;
      }

      // Regular expression to allow up to 2 decimal places
      const decimalRegex = /^\d*\.?\d{0,2}$/;

      // Exit the function if the value doesn't match the decimal format
      if (!decimalRegex.test(value)) {
        return;
      }
    }
    const tableDataInit = _.cloneDeep(packagedetailCreationlist?.boqs);
    tableDataInit[index][key] = value;
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      boqs: tableDataInit,
    }));
  };

  const handleEditClick = (rowIndex) => {
    setEditRowIndex(rowIndex);
    setModalDescription(packagedetailCreationlist?.boqs[rowIndex].description);
    setIsModalOpen(true);
  };

  const handleModalSubmit = () => {
    if (editRowIndex !== null) {
      const updatedData = [...packagedetailCreationlist?.boqs];
      updatedData[editRowIndex].description = modalDescription;
      setCreateTableArr(updatedData);
      setEditRowIndex(null);
      setIsModalOpen(false);
    }
  };

  const uploadFile = (e, document) => {
    addIsAlertUnsavedData();
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0];
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          onUploadMedia(response?.data?.data, document, files);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const onUploadMedia = (resData, uploadObj, files) => { 
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    if(!isEmptyDash(uploadObj.response)){
      uploadObj.response.push(obj);
    }else{
      uploadObj.value.response.push(obj);
    }
   
    setUploadFilesObj(uploadObj);
  };


  const getCategoryForProjects = () => {
    projectServices
      .getCategoryForProjects()
      .then((res) => {
        if (res.data.success === true) {
          setCategoriyList(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const formatDateForState = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const clearData = () => {
    addIsAlertUnsavedData();
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      // packageName: "",
      packageType: "",
      description: "",
      remarks: "",
      subcategoryId: "",
      departmentId: "",
      // dueDate: "",
      purchaseType: "",
      categoryId: "",
      boqs: [],
      documents: prevState.documents.map((doc) => ({
        ...doc,
        response: [],
      })),
    }));
  };

  const onBulkUploadSubmit = (fileDataParam, createTableArr) => {
    addIsAlertUnsavedData();
    let reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });
        if (roa.length) result[sheetName] = roa;
      });
      // see the result, caution: it works after reader event is done.
      let arr = [];
      let obj = {};

      for (let i = 0; i < createTableArr.length; i++) {
        let valIndex = result?.Sheet1[0]?.indexOf(createTableArr[i].value);
        let keyName = createTableArr[i].name;
        obj[keyName] = valIndex;
        // obj[`${keyName}Index`] = valIndex;
      }

      for (let j = 1; j < result?.Sheet1.length; j++) {
        let newObj = {};
        for (let key in obj) {
          newObj[key] = result?.Sheet1[j][obj[key]];
        }
        arr.push(newObj);
      }
      setPackageDetailCreationlist((prevState) => ({
        ...prevState,
        boqs: [...prevState.boqs, ...arr],
      }));
      setPrNumberDisabled((prevState) => [
        ...prevState,
        ...Array(arr.length).fill(true)
      ]);
      // setRows([...rows, newBoqEntry]);
      setOpenDefaulfFields(false);
      setTableData([...tableData, ...arr]);
      setCreateTableArr(createTableArr1);
      // onsetOpenDefaulfFields(false);
      // setFileData(file);
    };
    reader.readAsArrayBuffer(fileDataParam);
  };

  const onsetOpenDefaulfFields = (param) => {
    setOpenDefaulfFields(param);
  };
  const today = new Date().toISOString().split('T')[0];

  const deletePackage = () => {
    setIsLoading(true);
    packageServices
      .deletePackage(id)
      .then((res) => {
        if (res.data.success === true) {
          navigateUrl(`/admin/Project-Manager-Packages-Listing`);
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'Unable to delete.', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handlePRNumberChange = (id, key, value, index) => {
    const updatedBOQ = _.cloneDeep(packagedetailCreationlist?.boqs);
    updatedBOQ[index][key] = value; 
    setPackageDetailCreationlist((prevState) => ({
      ...prevState,
      boqs: updatedBOQ,
    }));

    // Update the disabled state of the current row
    handlePRNumberInputChange(value, index);
  };

  const savePrNo = () => {
    setIsLoading(true);
    const existingPrNumbers = new Set(
      initialBoqs.map((boq) => boq.prNumber ? boq.prNumber.trim() : '')
    );
    const updatedBoqs = packagedetailCreationlist.boqs
      .filter((boq) => {
        const trimmedPrNumber = boq.prNumber ? boq.prNumber.trim() : '';
        return trimmedPrNumber !== '' && !existingPrNumbers.has(trimmedPrNumber);
      })
      .map((boq) => ({
        boqId: boq._id,
        prNumber: boq.prNumber.trim(),
      }));

    if (updatedBoqs.length === 0) {
      openAlert(true, "success", "No new PR numbers to update.");
      setIsLoading(false);
      return;
    }

    const payload = { boqs: updatedBoqs };

    packageServices
      .addPRNumber(id, payload, 'packages')
      .then((res) => {
        if (res.data.success === true) {
          openAlert(true, "success", res.data.message);
          setTimeout(() => {
            navigateUrl(`/admin/Project-Manager-Packages-Listing`);
          }, 3000);

        } else {
          setIsLoading(false);
          openAlert(true, "error", `${res?.data?.data?.message}`);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const [prNumberDisabled, setPrNumberDisabled] = useState([]);
  const [prSaveButtonDisabled, setPrSaveButtonDisabled] = useState(false);

  useEffect(() => {
    if (packagedetailCreationlist?.boqs?.length && prNumberDisabled.length === 0) {
      const initialDisabledState = packagedetailCreationlist.boqs.map(() => true);
      setPrNumberDisabled(initialDisabledState);
    }
  }, [packagedetailCreationlist]);

  const enablePRNumberFields = () => {
    const updatedDisabledState = packagedetailCreationlist.boqs.map(boq => {
      return !(boq.prNumber === '' || boq.prNumber === undefined);
    });
    setPrNumberDisabled(updatedDisabledState);
  };

  const handlePRNumberInputChange = (value, index) => {
    const updatedDisabledState = [...prNumberDisabled];
    updatedDisabledState[index] = false;
    setPrNumberDisabled(updatedDisabledState);
  };

  const enableBlankPRNumberFields = () => {
    const updatedDisabledState = prNumberDisabled.map((isDisabled, index) => {
      return packagedetailCreationlist.boqs[index].prNumber === '' || packagedetailCreationlist.boqs[index].prNumber === undefined
        ? false
        : true;
    });
    setPrNumberDisabled(updatedDisabledState);
    setPrSaveButtonDisabled(true);
  };



  function formatFileName(fileName, maxLength = 15) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }
    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;

    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);

    return `${startText}...${endText}`;
  }
  const[activeDocument, setActiveDocument] = useState([]);
  const[activefields, setActiveFields] = useState([]);
  const getPackageFieldDetails = () => {
    setIsLoading(true); 
    packageServices
      .getPackageFieldList('BIDDING','PACKAGE')
      .then((res) => { 
        if (res.data.success === true) { 
            const filteredDocument = res.data?.data?.sections.filter(section => { 
              return section.title === "Documents";
            });
            const filteredFields = res.data?.data?.sections.filter(section => { 
              return section.title === "Fields";
            });
            setActiveFields(filteredFields);
            setActiveDocument(filteredDocument);
            if (initialDocuments.length === 0) {
              setInitialDocuments(filteredDocument); // Set initial documents only once
            }
            setactiveProjectFields( res.data?.data?.sections);
            
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };  
  const [syncedData, setSyncedData] = useState([]);
 
  const syncData = () => {
    const syncedFields = activefields.flatMap((fieldGroup) => {
      if (Array.isArray(fieldGroup.fields)) {
        return fieldGroup.fields.map((field) => {
          const fieldValue =
            packagedetailCreationlist[field.uniqueName] ||
            packagedetailCreationlist?.additionalFields?.[field.uniqueName] ||
            "N/A";
  
          let displayValue = fieldValue;
  
          if (field.type === "Dropdown" && Array.isArray(field.options)) {
            const matchedOption = field.options.find(
              (option) =>
                String(option._id) === String(fieldValue) ||
                String(option.optionName).toLowerCase() === String(fieldValue).toLowerCase()
            );
  
            displayValue = matchedOption ? matchedOption.optionName : "N/A";
          }
  
          return { ...field, value: displayValue };
        });
      }
      return [];
    });
  
    const syncedDocuments = activeDocument.flatMap((docGroup) => {
      if (Array.isArray(docGroup.fields)) {
        return docGroup.fields.map((document) => {
          const documentValue = packagedetailCreationlist.documents?.find(
            (doc) => doc.uniqueName === document.uniqueName
          );
  
          return {
            ...document,
            value: documentValue || "No Document Uploaded",
          };
        });
      }
      return [];
    });
    setActiveDocument(syncedDocuments);
    // setInitialDocuments(syncedDocuments);
    // Combine fields and documents
    const combinedSyncedData = [...syncedFields, ...syncedDocuments];
    setSyncedData(combinedSyncedData); 
  };

  useEffect(() => {
    // getPackageFieldDetails(); 
  }, [id]);

  useEffect(() => {
    if (activeProjectFields.length && Object.keys(packagedetailCreationlist).length) {
      syncData();
    }
  }, [activeProjectFields]);   


  const deleteFile = (index, key, idx) => { 
    if (!uploadFilesObj?.response || index < 0 || index >= uploadFilesObj.response.length) {
      console.error('Invalid index or response array.');
      return;
    } 
    const updatedFiles = uploadFilesObj.response.filter((_, i) => i !== index); 
    setActiveDocument((prevState) => {
      const updatedState = _.cloneDeep(prevState); 
      updatedState.forEach((doc) => {
        if (doc.uniqueName === uploadFilesObj.uniqueName) { 
          if (doc.value?.response) {
            doc.value.response = updatedFiles;
          } else {
            console.warn(`No response array found for document: ${doc.uniqueName}`);
          }
        }else{
           
        }
      }); 
      return updatedState;
    }); 
    setUploadFilesObj((prev) => ({
      ...prev,
      response: updatedFiles,
    })); 
  };
  // const deleteFile = (index, key, idx) => {
  //   const createPackageFieldsDetailsInit = _.cloneDeep(
  //     packagedetailCreationlist
  //   );
  //   const updatedFiles = uploadFilesObj.response.filter(
  //     (file, i) => i !== index
  //   );

  //   for (let i = 0; i < createPackageFieldsDetailsInit.documents.length; i++) {
  //     if (
  //       createPackageFieldsDetailsInit.documents[i].uniqueName ===
  //       uploadFilesObj?.uniqueName
  //     ) {
  //       createPackageFieldsDetailsInit.documents[i].response = [
  //         ...updatedFiles,
  //       ];
  //     }
  //   }
  //   setPackageDetailCreationlist(createPackageFieldsDetailsInit);
  //   const obj = { ...uploadFilesObj, response: [...updatedFiles] };
  //   setUploadFilesObj(obj);
  // };
  const [buyerAssignee, setBuyerAssignee] = useState(''); 
  useEffect(() => {  
      getBuyerEngineer();  
  }, []);
  
  const getBuyerEngineer = () => {
    setIsLoading(true);
    let param = "?roles=BUYER&departments=PROCUREMENT";
    rfqServices
      .getAssignEngineer(param)
      .then((res) => {
        if (res && res.data) {
          setBuyerAssignee(res?.data?.data?.assignees);
        } else {
          setAlertComponent({
            open: true,
            type: 'error',
            message: 'No Data Found',
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `${error?.response?.data?.message}`,
        }); 
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onAssignBuyerChange = () => {    
    let bodyData = {"buyer": selectedBuyers} 
    // console.log(bodyData);
        setIsLoading(true);
    packageServices
      .assignBuyer(id , bodyData)
      .then((res) => {          
        if (res.data.success === true) { 
         openAlert(true, "success", res.data.message);
         setTimeout(() => {
           navigateUrl(`/admin/Project-Manager-Packages-Listing`);
         }, 1000);
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'Unable to Assign.', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {  
    const buyers = Array.isArray(packagedetailCreationlist?.buyer)
      ? packagedetailCreationlist.buyer.map((buyer) => buyer.userId)
      : [];  
    setSelectedBuyers(buyers);   
  }, [packagedetailCreationlist?.buyer]);

  const handleBuyerChange = (event) => {
    const { value } = event.target;   
    console.log(value);
    
    setSelectedBuyers(value);  
    if (UserObj?.role?.name === "BUYER") {
      // onAssignBuyerChange(value); 
    } else {
      onFieldChange(value, "assignBuyer");  
    }
  };
  
  // const onOpenMulti = (event) => {
  //   console.log("onOopen");    
  // };
  
  const onCloseMulti = (event) => {
    console.log("onCloseMulti", selectedBuyers, initialAssignedBuyer); 
    let isBuyerModified = false;
    if (selectedBuyers?.length == initialAssignedBuyer?.length ) {        
      for (let i = 0; i < selectedBuyers.length; i++) {
        let str = false;
        for (let j = 0; j < initialAssignedBuyer.length; j++) {
          if (selectedBuyers[i] == initialAssignedBuyer[j]?.userId ) {
            str = true;
          }
        }
        if (str == false) {
          isBuyerModified = true;
          break;
        }
      }
    } else {
      isBuyerModified = true;
    }

    if (isBuyerModified == true) {
      // console.log("Modified"); 
      setIsConfirmModalOpen(true);
    } else {
      // console.log("Not Modified");      
    }
    // onAssignBuyerChange(selectedBuyers);   
  };
  
  const closeConfirmModal = () => {
    let arr = [];
    for (let i = 0; i < initialAssignedBuyer.length; i++) {
      arr.push(initialAssignedBuyer[i]?.userId);
    }
    setSelectedBuyers(arr);
    setIsConfirmModalOpen(false);
  };

  // const handleCheckboxChange = (e, buyerId) => {
  //   const newSelectedBuyers = [...selectedBuyers];
  //   if (e.target.checked) {
  //     newSelectedBuyers.push(buyerId);  
  //   } else {
  //     const indexToRemove = newSelectedBuyers.indexOf(buyerId);
  //     if (indexToRemove > -1) {
  //       newSelectedBuyers.splice(indexToRemove, 1);  
  //     }
  //   } 
  //   setSelectedBuyers(newSelectedBuyers);  
  // };


  const handleCheckboxChange = (e, buyerId) => {
    const isChecked = e.target.checked; 
    // console.log(isChecked, selectedBuyers);
      
    // setSelectedBuyers((prevSelectedBuyers) => {
    //   if (isChecked) { 
    //     return [...prevSelectedBuyers, buyerId];
    //   } else { 
    //     return prevSelectedBuyers.filter((id) => id !== buyerId);
    //   }
    // });
  };
  
  const[isBuyerAssignedPR , setIsBuyerAssignedPR] = useState(false);
  const isBuyerAssignedToLoggedInUser = (buyerList, loggedInUserId) => {
    if (!buyerList || !Array.isArray(buyerList)) {
      return false;  
    }
    const isAssigned = buyerList?.some((assignedBuyer) => assignedBuyer.userId === loggedInUserId); 
    return isAssigned;
  };
  useEffect(() => { 
    const isAssigned = isBuyerAssignedToLoggedInUser(packagedetailCreationlist?.buyer, UserObj?._id);  
    setIsBuyerAssignedPR(isAssigned); 
  }, [UserObj?._id, packagedetailCreationlist?.buyer]);

 
  const addIsAlertUnsavedData = () => {
    let obj = {
      msg: `If confirm, all changes/updates will be discarded in the form. Please save draft or submit the document first before leaving this page.`,
      showAlert: true,
    }
    sessionStorage.setItem("isAlertUnsavedData", JSON.stringify(obj));
  }

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="package_detail_msauto_iobj_row ms-auto">
            <div className="search_main">
              <h5>Package Detail </h5>
            </div>
         <div className="d-flex">

         { secEditAssignBuyerPermission?.read === true &&
         <div className="create_listing_project">
              <div className="package_creation_form_boq_type_body lets_select_sme">
                <p><b>  Assign Buyer</b> </p> 
                <FormControl className="seclected_form_detaila d-flex">
                  <Select
                    id="assignEngineer"
                    multiple
                    className="form-select_sectionpackage seclected_form_detail1ses2"
                    displayEmpty
                    value={selectedBuyers}
                    onChange={handleBuyerChange}
                    // onOpen={onOpenMulti}
                    onClose={onCloseMulti}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span>Select a Buyer</span>;
                      }
                      return selected
                        .map((id) => {
                          if (Array.isArray(buyerAssignee)) {
                            const buyer = buyerAssignee.find((buyer) => buyer._id === id);
                            return buyer ? buyer.name : id;
                          }
                          return id;
                        })
                        .join(", ");
                    }}
                    // style={{ minWidth: "200px" }} 
                  >  
                    {Array.isArray(buyerAssignee) && ( 
                      (() => { 
                        const isBuyerAssigned = isBuyerAssignedToLoggedInUser(packagedetailCreationlist.buyer, UserObj?._id);  
                        const isEngineer = UserObj?.role?.name === "ENGINEER";  
                        if (!isBuyerAssigned && !isEngineer) {
                          return buyerAssignee.map((data, index) => (
                            <MenuItem
                              key={index}
                              value={data._id}
                              disabled={true}  
                            >
                              <Checkbox
                                checked={selectedBuyers.includes(data._id)}  
                                disabled={true} 
                              />
                              <ListItemText primary={data.name} />
                            </MenuItem>
                          ));
                        } else { 
                          return buyerAssignee.map((data, index) => {
                            const isAssigned = packagedetailCreationlist?.buyer?.some(
                              (assignedBuyer) => assignedBuyer?.userId === data?._id
                            ); 
                            const isDisabled = !isAssigned && UserObj?.role?.name === "Buyer"; 
                            
                            return (
                              <MenuItem
                                key={index}
                                value={data._id}
                                disabled={isDisabled}
                              >
                                <Checkbox
                                  checked={selectedBuyers.includes(data._id)} 
                                  // onChange={(e) => handleCheckboxChange(e, data._id)}
                                  // disabled={isDisabled}
                                />
                                <ListItemText primary={data.name} />
                              </MenuItem>
                            );
                          });
                        }
                      })()
                    )}
                  </Select>
                </FormControl> 
              </div>
            </div>
          }


            <div>
            {secEditPackagePermission?.read === true && UserObj?.role?.name !== 'PROJECT_MANAGER' && packagedetailCreationlist?.noOfRfq === 0 && ( 
                    <div class="create_listing_project">
                      {isDisable && (
                        <button onClick={onEditClk} className="gate_btn_lr_creations">
                          <EditIcon />
                          Edit Package
                        </button>
                      )}
                    </div>
                  )} 
            </div> 
         </div>
             </div>

          <div className="">
            <div className="listing_project_block_1">
              {packagedetailCreationlist?.projectId && (
                <>
                  <div className="listing_project_block_2">
                    <div className="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Project Code:</b>
                      </p>
                      <p className="block_detail_listing">
                        <Tooltip title={packagedetailCreationlist?.projectCode}> {trimString(packagedetailCreationlist?.projectCode, 20)}</Tooltip>
                      </p>
                    </div>
                  </div>
                  <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Project Site Code:</b>
                      </p>

                      <p className="block_detail_listing">
                        <Tooltip title={packagedetailCreationlist?.projectCode}> {trimString(packagedetailCreationlist?.projectCode, 20)}</Tooltip>
                      </p>
                    </div>
                  </div>
                  <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Project Name:</b>
                      </p>
                      <p class="block_detail_listing">
                        <Tooltip title={packagedetailCreationlist?.projectName}> {trimString(packagedetailCreationlist?.projectName, 20)}</Tooltip>
                      </p>
                    </div>
                  </div>
                  {packagedetailCreationlist?.COD !== '' || packagedetailCreationlist?.COD !== undefined && (
                    <div class="listing_project_block_2">
                      <div class="listing_project_block_3">
                        <p className="project_code_texts_creationlisbv">
                          <b>COD:</b>
                        </p>
                        <p class="block_detail_listing">
                          <Tooltip title={packagedetailCreationlist?.COD}> {trimString(packagedetailCreationlist?.COD, 20)}</Tooltip>
                        </p>
                      </div>
                    </div>
                  )}
                  {packagedetailCreationlist?.projectLocation !== '' && (
                      <div class="listing_project_block_2">
                        <div class="listing_project_block_3">
                          <p className="project_code_texts_creationlisbv">
                            <b>Project Location:</b>
                          </p>
                          <p class="block_detail_listing">
                            <Tooltip title={packagedetailCreationlist?.projectLocation}> {trimString(packagedetailCreationlist?.projectLocation, 20)}</Tooltip>
                          </p>
                        </div>
                      </div>
                     )}
                     {packagedetailCreationlist?.noOfPackages !== '' && (
                        <div class="listing_project_block_2">
                          <div class="listing_project_block_3">
                            <p className="project_code_texts_creationlisbv">
                              <b>No. of Packages:</b>
                            </p>
                            <p class="block_detail_listing">
                              <Tooltip title={packagedetailCreationlist?.noOfPackages}> {trimString(packagedetailCreationlist?.noOfPackages, 20)}</Tooltip>
                            </p>
                          </div>
                        </div>
                     )}
                  {packagedetailCreationlist?.capacity !== '' && (
                  <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Capacity:</b>
                      </p>
                      <p class="block_detail_listing">
                        <Tooltip title={packagedetailCreationlist?.capacity}> {trimString(packagedetailCreationlist?.capacity, 20)}</Tooltip>
                      </p>
                    </div>
                  </div>
                  )}
                  <div class="listing_project_block_2_9">
                    <div class="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Created by:</b>
                      </p>
                      <p class="block_detail_listing">
                        <Tooltip title={packagedetailCreationlist?.createdBy}> {trimString(packagedetailCreationlist?.createdBy, 20)}</Tooltip>
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="listing_packagedetail_block_mainsection1">
              <div class="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Package Name<span className="required">*</span>:</b>
                  </p>
                  <Tooltip title={packagedetailCreationlist?.packageName || 'NA'}>
                  <input
                  className="form-control form-haswes"
                  type="text"
                  fdprocessedid="u2nmq"
                  value={trimString(packagedetailCreationlist?.packageName, 20)}
                  disabled
                  onChange={(e) => onTextChange(e)}
                  name="packageName"
                  />
                  </Tooltip>
                </div>
              </div>
              <div class="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Package Code:</b>
                  </p>
                  <Tooltip title={packagedetailCreationlist?.packageCode || 'NA'}>
                  <input
                 className="form-control form-haswes"
                    type="text"
                    fdprocessedid="u2nmq"
                    value={trimString(packagedetailCreationlist?.packageCode, 20)}
                    disabled
                    onChange={(e) => onTextChange(e)}
                    name="packageCode"
                  />
                  </Tooltip>
                </div>
              </div>
              <div class="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Category<span className="required">*</span>:</b>
                  </p>
                  {isDisable ? (
                    <Tooltip title={categoriyList.find(option => option._id === packagedetailCreationlist?.categoryId)?.categoryName || '' || 'NA'}>
                    <input
                     className="form-control form-haswes"
                      type="text"
                      fdprocessedid="u2nmq"
                      value={trimString(categoriyList.find(option => option._id === packagedetailCreationlist?.categoryId)?.categoryName || '')}
                      disabled={isDisable}
                      name="categoryId"
                    />
                    </Tooltip>
                  ) : (
                    <select
                      class="form-select package_creation_form_detail"
                      aria-label="Default select example"
                      fdprocessedid="zlera"
                      name="categoryId"
                      value={packagedetailCreationlist.categoryId}
                      onChange={(e) =>
                        onFieldChange(e.target.value, "categoryId")
                      }
                      disabled={isDisable}
                    >
                      <option value="">Please Select</option>
                      {categoriyList.map((optionData, j) => (
                        <>
                          <option value={optionData?._id} key={j}>
                            {optionData?.categoryName}
                          </option>
                        </>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div class="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Sub Category<span className="required">*</span>:</b>
                  </p>
                  {isDisable ? (
                      <Tooltip title={subCategoryList.find(option => option._id === packagedetailCreationlist?.subcategoryId)?.subCategoryName || ''|| 'NA'}>
                    <input
                      className="form-control form-haswes"
                      type="text"
                      fdprocessedid="u2nmq"
                      value={trimString(subCategoryList.find(option => option._id === packagedetailCreationlist?.subcategoryId)?.subCategoryName || '')}
                      disabled={isDisable}
                      name="subcategoryName"
                    />
                    </Tooltip>
                  ) : (
                    <select
                      class="form-select package_creation_form_detail"
                      aria-label="Default select example"
                      fdprocessedid="zlera"
                      name="subcategoryId"
                      value={packagedetailCreationlist?.subcategoryId}
                      onChange={(e) =>
                        onFieldChange(e.target.value, "subcategoryId")
                      }
                      disabled={isDisable}
                    >
                      <option value="">Please Select</option>
                      {subCategoryList.map((optionData, j) => (
                        <>
                          <option value={optionData?._id}>
                            {optionData?.subCategoryName}
                          </option>
                        </>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div class="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Department<span className="required">*</span>:</b>
                  </p>
                  {isDisable ? (
                     <Tooltip title={departmentList.find(option => option._id === packagedetailCreationlist?.departmentId)?.departmentName || ''|| 'NA'}>
                    <input
                      className="form-control form-haswes"
                      type="text"
                      fdprocessedid="u2nmq"
                      value={trimString(departmentList.find(option => option._id === packagedetailCreationlist?.departmentId)?.departmentName || '')}
                      disabled={isDisable}
                      name="departmentName"
                    />
                    </Tooltip>
                  ) : (
                    <select
                      class="form-select package_creation_form_detail"
                      aria-label="Default select example"
                      fdprocessedid="zlera"
                      name="departmentId"
                      value={packagedetailCreationlist.departmentId}
                      onChange={(e) =>
                        onFieldChange(e.target.value, "departmentId")
                      }
                      disabled={isDisable}
                    >
                      <option value="">Please Select</option>
                      {departmentList.map((optionData, j) => (
                        <>
                          <option value={optionData?._id} key={j}>
                            {optionData?.departmentName}
                          </option>
                        </>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div className="listing_project_block_2_1">
                <div class="listing_project_block_3">
                  <p className="project_code_texts_creationlisbv">
                    <b>Package Creation Date<span className="required">*</span>:</b>
                  </p>
                  <p class="block_detail_listing">
                    <Tooltip title={packagedetailCreationlist?.packageCreationDate}> {trimString(packagedetailCreationlist?.packageCreationDate, 20)}</Tooltip>
                  </p>
                </div>
              </div>
              {syncedData
                .filter((field) => field.section === "Fields")  
                .map((field) => { 
                  if (field.name === "Purchase Type") return null;
                  const value =
                    packagedetailCreationlist?.[field.uniqueName] ||  
                    packagedetailCreationlist?.additionalFields?.[field.uniqueName] ||  
                    "";   
                  return (
                    <div key={field._id} className="listing_project_block_2_1">
                      <div className="listing_project_block_3">
                        <p className="project_code_texts_creationlisbv">
                          <b>{field.name}{field.required && <span className="required">*</span>}:</b>
                        </p> 
                        {isDisable ? ( 
                          <input
                            className="form-control form-haswes"
                            type={field.type === "Number" ? "number" : "text"}
                            value={value}
                            disabled 
                            name={field.uniqueName}
                          />
                        ) : ( 
                          field.type === "Dropdown" ? (
                            <select
                              className="form-select package_creation_form_detail"
                              name={field.uniqueName}
                              value={ 
                                field.options?.find((option) => option.optionName === value)?.optionName || ""
                              }   
                              onChange={(e) =>
                                onFieldChange(e.target.value, field.uniqueName)  
                              }
                            >
                              <option value="">Please Select</option>
                              {field.options?.map((option, index) => (
                                <option key={index} value={option.optionName}>
                                  {option.optionName}   
                                </option>
                              ))}
                            </select>
                          ) : (
                            // Render as an editable input field for other types (e.g., text, number) when isDisable is false
                            <input
                              className="form-control form-haswes"
                              type={field.type === "Number" ? "number" : "text"}
                              value={value}
                              onChange={(e) =>
                                onFieldChange(e.target.value, field.uniqueName)  
                              }
                              name={field.uniqueName}
                            />
                          )
                        )}
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>
          <h5 className="lets_boq_outer">BOQ</h5>
          <div class="search_filter_outers ms-auto">
            <div class="seclected_form_detail_first">
              <h5 className="">Purchase Type</h5>
              {/* {isDisable ? ( */}
              <input
                className="form-control seclected_form_detaila"
                type="text"
                value={packagedetailCreationlist?.purchaseType || ''}
                disabled="disabled"
              />
              {/* // ) : (
              //   <select
              //     className="form-select seclected_form_detaila"
              //     aria-label="Default select example"
              //     value={packagedetailCreationlist.purchaseType || ''}
              //     onChange={(e) => onFieldChange(e.target.value, "purchaseType")}
              //   >
              //     <option value="" disabled>
              //       Select
              //     </option>
              //     <option value="Service">Service</option>
              //     <option value="Supply">Supply</option>
              //   </select>
              // )} */}
            </div> 
           {/* {(UserObj?.role?.name === 'BUYER' || UserObj?.role?.name === 'ENGINEER') && */}
              <div class="create_listing_project"> 
                { secEditPRNUMBERPermission?.read === true &&
                    <button
                      onClick={enableBlankPRNumberFields}
                      className="gate_btn_lr_creations"
                     // disabled={UserObj?.role?.name !== 'ENGINEER' && !isBuyerAssignedPR} 
                    > 
                      <EditIcon />
                      Add PR Number
                    </button>
                  }

                {/* {UserObj?.role?.name === 'ENGINEER' && */}
                <button
                  onClick={() => setOpenBulkUploadModal(true)}
                  className="gate_btn_lr_creations"
                  disabled={isDisable}
                  style={{ display: activeSubmitButton ? "block" : "none" }}
                >
                  <EditIcon />
                  Excel Upload
                </button>
                  {/* } */}
              </div>
            {/* //} */}




          </div>
          <div className="listing_main">
            <table>
              <thead>
                <tr>
                  {/* <th>
                    <input type="checkbox" />
                  </th> */}
                  <th className="vendor_tabels">Item No</th>
                  <th className="vendor_tabels">Description</th>
                  <th className="vendor_tabels">HSN/SAC Code</th>
                  <th className="vendor_tabels">PR No.</th>
                  <th className="vendor_tabels">UOM</th>
                  <th className="vendor_tabels">Quantity</th>
                  <th className="vendor_tabels">Rate (in INR)</th>
                  <th className="vendor_tabels">Amount (In INR)</th>
                  {!isDisable && packagedetailCreationlist?.boqs?.length > 1 && (
                    <th className="vendor_tabels">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* {packagedetailCreationlist?.boqs?.length > 0 && <> */}
                {/* {packagedetailCreationlist?.boqs?.map((row, rowIndex) => ( */}
                {packagedetailCreationlist?.boqs?.length < 1 && (
                  <>
                    <tr>
                      <td colSpan={10} className="text-center list-no-data">
                        No Data Found
                      </td>
                    </tr>
                  </>
                )}
                {packagedetailCreationlist?.boqs?.map((row, i) => (
                  <tr key={row.id} className="maine_tr_vendor">
                    {/* <td>
                      <input type="checkbox" />
                    </td> */}
                    <td>{i + 1}</td>
                    <td>
                      <div className="custom_main_row_feactures">
                        <div id="custom-search-input" style={{ padding: '0px' }}>
                          <div className="input-group col-md-12">
                            <Tooltip title={row.description}>
                              <input
                                className="form-control input-lg"
                                type="text"
                                placeholder=""
                                value={formatFileName(row.description)}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value.length <= 350) {
                                    handleChange(row.id, "description", value, i);
                                  }
                                }}
                                maxLength="350"
                                disabled={isDisable}
                              /></Tooltip>
                            <span className="input-group-btn">
                              <button
                                className="btn btn-info btn-lg"
                                type="button"
                                fdprocessedid="trsp06"
                                onClick={() => handleEditClick(i)}
                              // disabled={isDisable}
                              >
                                <span className="glyphicon glyphicon-search">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.146 0.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 3L3 11.207V13h1.793L13 4.793 11.207 3zM1 13.5V15h1.5l.896-.447-2-2L1 13.5z" />
                                  </svg>
                                </span>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.hsnSacCode}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            handleChange(row.id, "hsnSacCode", e.target.value, i);
                          }
                        }}
                        // onKeyDown={(e) => {
                        //   if (["e", "E", "+", "-", "."].includes(e.key)) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        maxLength="10"
                        pattern="\d*"
                        disabled={isDisable}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.prNumber || ""}
                        maxLength="20"
                        disabled={prNumberDisabled[i]}
                        //  disabled={prNumberDisabled}
                        onChange={(e) => {
                          handlePRNumberChange(row.id, "prNumber", e.target.value, i);
                          // handlePRNumberInputChange(e.target.value, i);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.uom}
                        // onChange={(e) =>
                        //   handleChange(row.id, "uom", e.target.value, i)
                        // }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 20) {
                            handleChange(row.id, "uom", value, i);
                          }
                        }}
                        // onBlur={(e) => {
                        //   const value = e.target.value;
                        //   if (value.length < 15) {
                        //     openAlert(true, "error", `Please Enter  UOM at least 15 to 20 characters.`);
                        //     handleChange(row.id, "uom", "", i);
                        //     return;
                        //   }
                        // }}
                        maxLength="20"
                        disabled={isDisable}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.quantity}
                        onChange={(e) =>
                          handleChange(row.id, "quantity", e.target.value, i)
                        }
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-", "."].includes(e.key) && e.key !== ".") {
                            e.preventDefault();
                          }
                        }}
                        disabled={isDisable}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.rate}
                        onChange={(e) =>
                          handleChange(row.id, "rate", e.target.value, i)
                        }
                        disabled
                      />
                    </td>
                    <td className="lets_package_detail_input_div_react_haswe">
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.amount}
                        onChange={(e) =>
                          handleChange(row.id, "amount", e.target.value, i)
                        }
                        disabled
                      />
                    </td>

                    <td>
                      {!isDisable && packagedetailCreationlist?.boqs?.length > 1 && (
                        <HighlightOffIcon
                          className="highlight_close_btn"
                          disabled={isDisable}
                          onClick={() => confirmDelete(row._id, i)}
                        />
                      )}
                    </td>
                  </tr>
                  
                ))}
                  <td></td>
                <td></td>
                <td></td>
                <td></td>
            
                <td className="">Total</td>
                <td>{totalQuantity}</td>
                <td>{totalRate}</td>
                <td>{totalAmount}</td>
                <td></td>
              </tbody>
            </table>
          </div>

          <div>
            {/* <table style={{ width: "100%" }}>
              <tr className="maine_tr_vendor">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>{totalQuantity}</td>
                <td>{totalRate}</td>
                <td>{totalAmount}</td>
                <td></td>
              </tr>
            </table> */}
            {secPackagePermission?.update === true && (
              <button
                className="lets_add_row_react_btn_packagedetail1"
                tabindex="0"
                type="button"
                fdprocessedid="9un26w"
                onClick={addRow}
                style={{ display: activeSubmitButton ? "block" : "none" }}
              >
                <AddIcon /> Add Row
                <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            )}
          </div>

          <div>
            <label>Remarks</label>
            <input
              className="form-control form-hasw"
              name="remarks"
              disabled={isDisable}
              onChange={(e) => onTextChange(e)}
              type="text"
              value={packagedetailCreationlist?.remarks}
            />
          </div>

          <div class="listing_block_maine_allbtn package_detail_allbtn_projectmanager" style={{ display: "inline" }}>
            {/* <div className="package_detail_allbtn_projectmanager">
              {packagedetailCreationlist?.documents &&
                packagedetailCreationlist.documents.map((document, index) => (
                  <>
                    <div>
                      <p className="package_projectmanager">
                        {document.documentName}
                        {index < 4 && <span class="required">*</span>}
                      </p>
                      {!isEmptyDash(document.response[0]?.key) && (
                        <>
                          <div
                            className="selected-file-present-div"
                            style={{ display: "inline" }}
                          >
                            { }
                            <span className="selected-file-present-text">
                              Document: {document?.response?.length}{" "}
                            </span>
                          </div>
                          <button
                            className="file-upload-btn"
                            // disabled={isDisable}
                            onClick={() => handleClick(document, index)}
                          >
                            View
                          </button>
                        </>
                      )}

                      <div
                        className="lets_block_package_listing_bom_file"
                        style={
                          isEmptyDash(document.response[0]?.key)
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        <input
                          className="form-control form-hchoose teee"
                          type="file"
                          ref={fileInputRef}
                          disabled={isDisable}
                          onChange={(e) => uploadFile(e, document)}
                        />

                      </div>

                    </div>
                  </>
                ))}
            </div> */}
 <div  className="package_detail_allbtn_projectmanager"> 
 {Array.isArray(activeDocument) &&
  activeDocument?.map((field, index) => (
    <div key={field._id}> 
      {Array.isArray(field?.value?.response) && field.value.response.length > 0 ? (
        <>
          <p className="package_projectmanager">{field.name}{field.required && <span className="required">*</span>}</p>
          <div
            className="selected-file-present-div"
            style={{ display: "inline" }}
          >
            <span className="selected-file-present-text">
              Document {field.value.response.length}
            </span>
          </div>
          <button
            className="file-upload-btn"
            onClick={() => handleClick(field, index)}
          >
            View
          </button>
        </>
      ) : (
        <>
          <p className="package_projectmanager">{field.name}{field.required && <span className="required">*</span>}</p>
          <div className="lets_block_package_listing_bom_file">
            <input
              className="form-control form-hchoose teee"
              type="file"
              ref={fileInputRef}
              disabled={isDisable}
              onChange={(e) => uploadFile(e, field)}
            />
          </div>
        </>
      )}
    </div>
  ))}
 
  </div>


            {/* <div className="package_detail_allbtn_projectmanager">
              {packagedetailCreationlist?.documents &&
                packagedetailCreationlist.documents.map((document, index) => (
                  <div key={index}>

                    {!isEmptyDash(document.response[0]?.key) ? (
                      <>
                        <p className="package_projectmanager">
                          {document.documentName} 
                        </p>
                        <div
                          className="selected-file-present-div"
                          style={{ display: "inline" }}
                        >
                          <span className="selected-file-present-text">
                            Document: {document?.response?.length}{" "}
                          </span>
                        </div>
                        <button
                          className="file-upload-btn"
                          onClick={() => handleClick(document, index)}
                        >
                          View
                        </button>
                      </>
                    ) : (
                      <>
                        <p className="package_projectmanager">
                          {document.documentName}
                        </p>
                        <div className="lets_block_package_listing_bom_file">
                          <input
                            className="form-control form-hchoose teee"
                            type="file"
                            ref={fileInputRef}
                            disabled={isDisable}
                            onChange={(e) => uploadFile(e, document)}
                          />
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div> */}

            
          </div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => 999999,
            }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          {showConfirmation && (
            <Modal
              open={showConfirmation}
              onClose={handleCancel}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Confirm Delete</h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleCancel}
                  ></button>
                </div>
                <div class="modal-bodys">
                  Are you sure you want to delete this Line Item ?
                  <div class="clear_btn_status_modified_boq">
                    <button type="button" class="btn btn-secondary" onClick={handleCancel}>
                      No
                    </button>
                    <button type="button" class="btn btn-success" onClick={handleConfirm}>
                      Yes
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          )}

          <div class="closebtn_submit_block_btn">
            {/* {secPackagePermission?.update === true && ( */}
            <>
            <button
                type="button"
                class="btn clear_btn_status_block_lists"
                fdprocessedid="wshspp"
                style={{ display: activeSubmitButton ? "block" : "none" }}
                onClick={(e) => clearData()}
              >
                Clear
              </button> 
            {packagedetailCreationlist?.status !== 'Created' && ( 
              <>
              <button
                type="button"
                class="btn clear_btn_status_block_lists"
                fdprocessedid="wshspp"
                onClick={() => setDeletePackageModal(true)}
                style={{ display: activeSubmitButton ? "block" : "none" }}
              >
                Discard
              </button>
              
              <button
                type="button"
                class="btn btn-success save_next_btns"
                fdprocessedid="cn5f6"
                onClick={(e) => submitForm(false)}
                style={{ display: activeSubmitButton ? "block" : "none" }}
              >
                Save as Draft
              </button>
              </>
            )}

              <button
                type="button"
                class="btn btn-success save_next_btns"
                fdprocessedid="cn5f6"
                onClick={(e) => submitForm(true)}
                style={{ display: activeSubmitButton ? "block" : "none" }}
              >
                Submit
              </button>
            </>
            {/* )} */}

            {secEditPRNUMBERPermission?.read === true && prSaveButtonDisabled === true &&
              <button
                type="button"
                class="btn btn-success save_next_btns"
                fdprocessedid="cn5f6"
                onClick={(e) => savePrNo(true)}
              // style={{ display: activeSubmitButton ? "block" : "none" }}
              >
                Save PR No
              </button>
            }
          </div>


          {/* ProjectManager Bidding Edit BOQ  */}
          {isModalOpen && (
            <BoqDescriptionModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              handleModalSubmit={handleModalSubmit}
              setModalDescription={setModalDescription}
              modalDescription={modalDescription}
              title="Description"
              isDisablee={isDisable}
            />
          )}
          <BulkUploadModal
            createTableArr={createTableArr}
            openBulkUploadModal={openBulkUploadModal}
            setOpenBulkUploadModal={setOpenBulkUploadModal}
            onBulkUploadSubmit={onBulkUploadSubmit}
            onsetOpenDefaulfFields={onsetOpenDefaulfFields}
            openDefaulfFields={openDefaulfFields}
            sampleProjectFile={samplePackageFile}
            title="Create BOQ (Upload Excel File)"

          />

          <PackageDocuments
            isMediaListModalOpen={isMediaListModalOpen}
            closeMediaListModal={closeMediaListModal}
            uploadObj={uploadFilesObj}
            onUploadMedia={onUploadMedia}
            deleteFile={deleteFile}
            isSubmitCondition={false}
            multiupload={UserObj?.role?.name === 'ENGINEER' && editMultiUpload}
            userDeletefile={true && (isDisable === false)}
            editStatus={editPackage ? true : false}
          />
          
          {/* Confirm Modal */}
          <ConfirmModal
            isConfirmModalOpen={isConfirmModalOpen}
            closeConfirmModal={closeConfirmModal}
            successConfirmModal={onAssignBuyerChange}
            modalMsg={`Do you want to update the changes?`}
            status={""}
          />
          
          <Modal
            open={openeditboqpackage}
            onClose={() => setOpenEditBoqPackage(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Edit BOQ
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenEditBoqPackage(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <p>
                      You don't have access to this feature, please contact to
                      the Engineer
                    </p>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openCreateEmp}
            onClose={closeCreateEmp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employee">
              <div className="modal-header">
                <h5 className="modal-titles" id="uploadexcelfileLabel">
                  Upload Excel File
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeCreateEmp}
                ></button>
              </div>
              <div className="modal-body lets_modal_body_block_listing">
                <div id="vendorForm">
                  <div className="lets_modal_vendor2">
                    <p>Upload Excel Template</p>
                    <div className="master_panel_icon_react">
                      <input
                        className="form-control form-h choose"
                        type="file"
                        id="fileInput"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </div>

                    <div className="clear_btn_status">
                      <button
                        type="button"
                        className=" btn btn-warning"
                        data-dismiss="modal"
                        fdprocessedid="3pe65"
                        onClick={closeCreateEmp}
                      >
                        Close
                      </button>
                      <button
                        // style={{ color: isDeleteDisabled ? "grey" : "red" }}
                        // disabled={isDeleteDisabled}
                        type="button"
                        className="btn btn-success"
                        fdprocessedid="sqi0b"
                        onClick={onImport}
                      >
                        Import
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Package Discard Modal */}
          <Modal
            open={deletePackageModal}
            onClose={() => setDeletePackageModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() =>
                    setDeletePackageModal(false)
                  }
                ></button>
              </div>
              <div class="modal-bodys">
                Are you sure you want to Cancel Package, this will delete this Package ?
                <div class="clear_btn_status_modified_boq">
                  <button type="button" class="btn btn-secondary"
                    onClick={() =>
                      setDeletePackageModal(false)
                    }
                  >
                    No
                  </button>
                  <button type="button" class="btn btn-success"
                    onClick={deletePackage}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
            open={openboqupdatesuccessfully}
            onClose={() => setOpenBoqUpdateSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {editSubmitStatus === false ? 'Save Package as Draft' : 'Submit Package'}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenBoqUpdateSuccessfully(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div>

                <p>
                  {(editSubmitMessage) ? editSubmitMessage : 'Package Submited Successfully'}
                </p>
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => navigateUrl(`/admin/Project-Manager-Packages-Listing`)}
                >
                  Done

                </button>
              </div>
            </Box>
          </Modal>

          {/* Table Modal Create Boq */}
          {/* <Modal
            open={openDefaulfFields}
            onClose={() => setOpenDefaulfFields(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employee">
              <div className="modal-header">
                <h5 className="modal-titles" id="uploadexcelfileLabel">
                  Create Boq
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setOpenDefaulfFields(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p className="field_ptag_body">Defaulf Fields</p>
                <div className="vendor_configuration_list_block">
                  <table className="table" id="employeeTable">
                    <thead>
                      <tr>
                        <th className="vendor_tabels">LIST OF FIELDS</th>
                        <th className="vendor_tabels">COLUMNS IN XLS FILE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {createEmpTableArr.map((ele, i) => (
                        <>
                          <tr>
                            <td>{ele?.label}</td>
                            <td>
                              <select
                                className="form-select employeecreation"
                                name="role[]"
                                value={ele?.value}
                                onChange={(e) =>
                                  openCreateEmpSelectChange(e, ele, i)
                                }
                              >
                                <option value="" disabled={true}>
                                  Please Select
                                </option>
                                {fileInput.map((optionData, j) => (
                                  <>
                                    <option value={optionData}>
                                      {optionData}
                                    </option>
                                  </>
                                ))}
                              </select>
                              <span id="businessNameError" className="error">
                                {ele?.errMsg}
                              </span>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                  <div className="clear_btn_status">
                    <button
                      type="button"
                      className="clear_btn_status_block_list_btnclose"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-success save_next_btn"
                      onClick={boqCreationBulk}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Box>
          </Modal> */}


          <AlertComponent
            alertComponent={alertComponent}
            handleClose={handleClose}
          />
        </div>
      </div >
    </>
  );
}

export default PackageDetail;
